import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const Process = () => {
  const { t } = useLang();
  return (
    <section id="process" data-testid="process-section" className="bg-[var(--bg-secondary)] py-24 md:py-36">
      <div className="container-page">
        <div className="flex items-center gap-3 text-xs font-mono uppercase tracking-[0.18em] text-neutral-500 mb-10">
          <span className="w-8 h-px bg-neutral-400" />
          {t.process.eyebrow}
        </div>
        <h2 data-testid="process-title" className="font-display text-4xl md:text-6xl tracking-tight max-w-3xl">
          {t.process.title}
        </h2>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-4 gap-px bg-[var(--border)]">
          {t.process.steps.map((s, i) => (
            <div
              key={s.num}
              data-testid={`process-step-${i}`}
              className="bg-[var(--bg-secondary)] p-8 md:p-10 group transition-colors hover:bg-white"
            >
              <div className="font-display text-6xl md:text-7xl text-neutral-300 group-hover:text-[var(--accent)] transition-colors">
                {s.num}
              </div>
              <div className="mt-6 font-display text-2xl md:text-3xl">{s.title}</div>
              <p className="mt-3 text-neutral-600 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
